import { Option, ReferenceData } from './reference-data.types';

const PARTY_TYPES: ReadonlyArray<Option> = [
  { value: 'FISHFARM', label: 'FishFarm' },
  { value: 'PROCESSING_PLANT', label: 'Processor' },
  { value: 'FEEDMILL', label: 'Feedmill' },
  { value: 'HATCHERY', label: 'Hatchery' },

  // split the slash-separated group into distinct values
  { value: 'DISTRIBUTOR', label: 'Distributor' },
  { value: 'TRADER', label: 'Trader' },
  { value: 'BROKER', label: 'Broker' },

  { value: 'RETAILER', label: 'Retailer' },

  // split exporter/importer
  { value: 'EXPORTER', label: 'Exporter' },
  { value: 'IMPORTER', label: 'Importer' },

  // split storage/freezer
  { value: 'STORAGE', label: 'Storage' },
  { value: 'FREEZER', label: 'Freezer' },

  { value: 'SUPPLIER', label: 'Supplier' },
  { value: 'VESSEL', label: 'Vessel' },

  {
    value: 'OTHER_SUPPORTING_PARTY',
    label: 'Other ',
  },
];

const UNITS: ReadonlyArray<Option> = [
  { value: 'EA', label: 'Each' },
  { value: 'Kg', label: 'Kilogram' },
  { value: 'LB', label: 'Pound' },
];

const PACKAGE_UNITS: ReadonlyArray<Option> = [
  { value: 'CS', label: 'Case' },
  { value: 'CT', label: 'Carton' },
  { value: 'BX', label: 'Box' },
  { value: 'BG', label: 'Bag' },
  { value: 'PLT', label: 'Pallet' },
  { value: 'CNT', label: 'Container' },
];

const FEED_TYPES: ReadonlyArray<Option> = [
  { value: 'FISHMEAL', label: 'Fishmeal' },
  { value: 'FISH_OIL', label: 'Fish oil' },
  { value: 'BY_PRODUCT_MEAL', label: 'By-product meal (trimmings)' },
  { value: 'SOYMEAL', label: 'Soymeal / SPC' },
  { value: 'WHEAT_CORN_GLUTEN', label: 'Wheat / corn gluten meal' },
  { value: 'RICE_BRAN', label: 'Rice bran' },
  { value: 'POULTRY_BY_PRODUCT_MEAL', label: 'Poultry by-product meal' },
  { value: 'BLOOD_MEAL', label: 'Blood meal' },
  { value: 'INSECT_PROTEIN', label: 'Insect protein' },
  { value: 'ALGAL_OIL', label: 'Algal oil' },
  { value: 'SINGLE_CELL_PROTEINS', label: 'Single-cell proteins' },
  { value: 'COMPOUND_FEED', label: 'Compound / pelleted diets' },
];

const PROTEIN_SOURCES: ReadonlyArray<Option> = [
  { value: 'fishmeal', label: 'Fishmeal' },
  { value: 'fish_oil', label: 'Fish oil' },
  { value: 'soymeal', label: 'Soymeal' },
  { value: 'grains', label: 'Grains' },
  { value: 'insect_protein', label: 'Insect protein' },
  { value: 'algae', label: 'Algae' },
  { value: 'compound_feed', label: 'Compound feed' },
];

export const DEFAULT_REFERENCE_DATA: ReferenceData = Object.freeze({
  partyTypes: PARTY_TYPES,
  units: UNITS,
  packageUnits: PACKAGE_UNITS,
  feedTypes: FEED_TYPES,
  proteinSources: PROTEIN_SOURCES,
});
